module.exports = __webpack_public_path__ + "img/hu2.708836dd.jpg";